import { useInfrastructureSectionContent } from './useInfrastructureSectionContent';
import { parseInfrastructureNeverStaticContent } from '../utils/infrastructureContent';

export const useInfrastructureNeverStaticContent = () =>
  useInfrastructureSectionContent(parseInfrastructureNeverStaticContent);
